import {  logOut } from '@/api/login'
import { Notification, MessageBox, Message } from 'element-ui'


const user = {
  state: {

  },

  mutations: {

  },

  actions: {
    // 登录
    // Login({ commit }, userInfo) {
    //   const username = userInfo.username.trim()
    //   const password = userInfo.password
    //   const code = userInfo.code
    //   const uuid = userInfo.uuid
    //   const publicKey = userInfo.publicKey
    //   console.log(publicKey)
    //   // return
    //   return new Promise((resolve, reject) => {
    //     login(username, password, code, uuid, publicKey).then(res => {
    //       setToken(res.token)
    //       commit('SET_TOKEN', res.token)
    //       resolve()
    //     }).catch(error => {
    //       reject(error)
    //     })
    //   })
    // },

    // 退出系统
    LogOut({ commit, state }) {
      return new Promise((resolve, reject) => {
        let userInfo = JSON.parse(sessionStorage.getItem('userInfo'))
        logOut({ldGx007a:userInfo.ldGx007a}).then(() => {
          sessionStorage.removeItem('userInfo')
          localStorage.removeItem('AIuserInfo')
          Message({
            message: '退出成功！',
            type: 'success'
          })
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 前端 登出
    FedLogOut({ commit }) {
      return new Promise(resolve => {
        commit('SET_TOKEN', '')
        commit('SET_TOKENS', '')
        sessionStorage.removeItem('userInfo')
        sessionStorage.removeItem('videoToken')
        localStorage.removeItem('AIuserInfo')

        // removeToken()
        // removeTokenByDataEase()
        resolve()
      })
    }
  }
}

export default user
